import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { IMessage } from 'message-notification-service-lib';
import { MatTooltip } from '@angular/material/tooltip';

export interface IAlertBannerMessage {
  id: IMessage;
  message: string;
  theme: string;
  time: string;
  dismissMs: number | null;
  copied?: boolean;
  details?: string;
  reference?: string;
  paused?: boolean;
  hovered?: boolean;
  focused?: boolean;
}

export interface AlertBannerSnackBarData {
  messages: IAlertBannerMessage[];
  hide: (id: IMessage) => void;
  pauseDismissal: (id: IMessage) => void;
  resumeDismissal: (id: IMessage) => void;
}

@Component({
  selector: 'app-alert-banner-snack-bar',
  templateUrl: './alert-banner-snack-bar.component.html',
  styleUrls: ['./alert-banner-snack-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatIcon, MatTooltip],
})
export class AlertBannerSnackBarComponent {
  private static readonly ERROR_THEME = 'error';

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: AlertBannerSnackBarData) {}

  get messages(): IAlertBannerMessage[] {
    return this.data.messages;
  }

  isError(msg: IAlertBannerMessage): boolean {
    return msg.theme === AlertBannerSnackBarComponent.ERROR_THEME;
  }

  onClose(msg: IAlertBannerMessage): void {
    this.data.hide(msg.id);
  }

  onPointerEnter(msg: IAlertBannerMessage): void {
    msg.hovered = true;
    this.applyPauseState(msg);
  }

  onPointerLeave(msg: IAlertBannerMessage): void {
    msg.hovered = false;
    this.applyPauseState(msg);
  }

  onFocusIn(msg: IAlertBannerMessage): void {
    msg.focused = true;
    this.applyPauseState(msg);
  }

  onFocusOut(msg: IAlertBannerMessage): void {
    msg.focused = false;
    this.applyPauseState(msg);
  }

  copyToClipboard(msg: IAlertBannerMessage): void {
    const listener = (e: ClipboardEvent) => {
      const data = JSON.stringify({ time: msg.time, details: msg.id }, null, 2);
      e.clipboardData?.setData('text/plain', data);
      e.preventDefault();
      document.removeEventListener('copy', listener);
      msg.copied = true;
      setTimeout(() => (msg.copied = false), 250);
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
  }

  private applyPauseState(msg: IAlertBannerMessage): void {
    const shouldPause = msg.hovered === true || msg.focused === true;
    if (shouldPause === (msg.paused === true)) {
      return;
    }

    msg.paused = shouldPause;

    if (shouldPause) {
      this.data.pauseDismissal(msg.id);
      return;
    }

    this.data.resumeDismissal(msg.id);
  }
}
